import { z } from 'zod';

const RejectionReasonSchema = z
  .object({
    code: z.string(),
    label: z.string(),
  })
  .describe('RejectionReason');

export const GetSeedingProposalRejectionReasonsServiceResponseSchema = z
  .object({
    reasons: z.array(RejectionReasonSchema),
  })
  .describe('GetSeedingProposalRejectionReasonsServiceResponseSchema');

export type RejectionReason = z.infer<typeof RejectionReasonSchema>;

export type GetSeedingProposalRejectionReasonsServiceResponse = z.infer<
  typeof GetSeedingProposalRejectionReasonsServiceResponseSchema
>;
